export default __webpack_public_path__ + "static/media/patients.b9017cf3.jpg";